import { useState } from 'react';
import { selectCurrentUser } from '../../redux/user/user.selector';
import axios from 'axios';
// import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

// import Modal from '../../components/modal/modal.component';
import PasswordGenerator from '../../components/password-generator/password-generator.component';
import EmailInput from '../../components/email-input/email-input.component';
import { useSelector } from 'react-redux';

export default function PasswordResetPage() {
  const currUser = useSelector(selectCurrentUser);
  let [email, setEmail] = useState('');
  let [password, setPassword] = useState('');
  let [loading, setLoading] = useState(false);
  let [loadingNavitaire, setLoadingNavitaire] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  /**
   * Interacts with dino Pass API to request random passwords
   * @returns The random password
   */
  async function getPassword() {
    setLoading(true);
    setIsCopied(false);
    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');

      const body = {
        test: 'event',
      };

      const options = {
        method: 'POST',
        headers,
        mode: 'cors',
        body: JSON.stringify(body),
      };

      let res = await fetch('https://eokcsjp3aaq6rpf.m.pipedream.net', options);
      let obj = await res.json();

      setPassword(obj.value);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setPassword('Error: Please try again.');
      setLoading(false);
      return error;
    }
  }

  async function copyPasswordToClipboard() {
    try {
      if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(password);
      } else {
        document.execCommand('copy', false, password);
      }
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3 * 1000);
    } catch (error) {
      console.log(error);
      setIsCopied(false);
    }
  }

  async function resetPassword() {
    setLoadingNavitaire(true);
    let res;
    try {
      console.log(password, email);
      res = await axios({
        method: 'post',
        url:
          process.env.REACT_APP_LOCAL_URL + '/automation/resetCustomerPassword',
        data: {
          password: password,
          email: email,
          userAuth: currUser,
        },
      });

      //   console.log(res);
      alert(res.data.message);
      setLoadingNavitaire(false);
    } catch (error) {
      console.log(error.response);
      alert(error.response.data.message);
      setLoadingNavitaire(false);
      return error;
    }
  }

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <PasswordGenerator
          password={password}
          getPassword={getPassword}
          setPassword={setPassword}
          loading={loading}
          isCopied={isCopied}
          copyPassword={copyPasswordToClipboard}
        />
        <EmailInput
          email={email}
          setEmail={setEmail}
          loading={loadingNavitaire}
          handleClick={resetPassword}
          button={true}
          buttonText={'Reset Password'}
        />
      </Container>
    </>
  );
}
